import { ApiWorkflowDialog, DataGrid, DataGridLayout } from '@verantos-dev/shared-components';

import { useViewDatasetDetailModal } from '../hooks/useViewDatasetDetailModal';

export const ViewDatasetDetailModal = () => {
  const { dialogHeader, onClose, useDatasetDetailQuery, columns } = useViewDatasetDetailModal();
  return (
    <ApiWorkflowDialog
      id={'useInfoDialog'}
      title={dialogHeader}
      size="full"
      isValidForSubmit={true}
      displayButtons={false}
      onClose={onClose}
    >
      <DataGridLayout id="dataset-detail-datagrid-layout">
        <DataGrid
          id="dataset-detail-list"
          mode="client"
          getRowId={(row) => row.file_number}
          columns={columns}
          useFetchDataGridData={useDatasetDetailQuery}
          getRowCount={(data) => data.pagination.total}
          disableSearchParamSync
          disableColumnSelector
          disableColumnPinning
          initialState={{
            sorting: {
              sortModel: [{ field: 'file_number', sort: 'asc' }],
            },
          }}
          slotProps={{
            columnHeaders: {
              style: {
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                lineHeight: 'normal',
                padding: '16px 24px',
                fontWeight: '500',
                fontSize: '14px',
                color: '#252A36',
              },
            },
          }}
        />
      </DataGridLayout>
    </ApiWorkflowDialog>
  );
};

export default ViewDatasetDetailModal;
